import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { resolveServer } from './environments/resolve-server';

if (environment.production) {
  enableProdMode();
}

// Point the environment at this client's backend (instance_config.serverurl) before any service is created.
resolveServer(environment)
  .then(() => platformBrowserDynamic().bootstrapModule(AppModule))
  .catch(err => console.error(err));
